module.exports = __webpack_public_path__ + "static/img/demo_user3.8c3e837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/placeholders/demo_user3.png
// module id = I9te
// module chunks = 31